import { useEffect, ReactNode, FC } from 'react';
import { useDispatch } from 'react-redux';
import { updateScreenSize } from '../store/slices/responsiveSlice';

interface ResponsiveProviderProps {
  children: ReactNode;
}

const ResponsiveProvider: FC<ResponsiveProviderProps> = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleResize = (): void => {
      dispatch(updateScreenSize(window.innerWidth));
    };

    // Imposta il valore iniziale
    handleResize();

    // Aggiungi listener per il resize
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, [dispatch]);

  return <>{children}</>;
};

export default ResponsiveProvider;
